import type { BaseLayoutProps } from 'fumadocs-ui/layouts/shared'
import { BookMarked, Newspaper } from 'lucide-react'
import Wordmark from '@/src/components/Wordmark'

// Nav items rendered in the middle column of the top nav, between the
// logo and the search bar. Exported so our custom header slot
// (`src/components/NavHeader`) can consume it; deliberately NOT
// passed via Fumadocs' `links` option, because that flow places text
// items on the far right of the header — we want the classic "Logo |
// Nav — — Search | Icons" layout (Tailwind / Next.js docs style) with
// the items aligned under the main content column.
//
// Icons chosen for semantic clarity + visual distinction at 16px:
//   Docs         -> BookMarked   (saved reference material)
//   Blog         -> Newspaper    (published articles)
export const navLinks = [
  {
    text: 'Docs',
    url: '/docs/introduction',
    activeBase: '/docs',
    icon: <BookMarked />,
  },
  {
    text: 'Blog',
    url: '/blog',
    activeBase: '/blog',
    icon: <Newspaper />,
  },
]

export function baseOptions(): BaseLayoutProps {
  return {
    nav: {
      title: (
        <Wordmark
          style={{ display: 'inline-block', fontSize: '22px', lineHeight: 1 }}
        />
      ),
      // NOTE: no `nav.children` here — the nav link strip is rendered
      // directly inside our custom header slot (`NavHeader`) so it
      // lands in the middle grid column, right under the main content.
      // Fumadocs would otherwise stash `children` next to `navTitle`
      // in the left cell, which is the wrong column.
    },
    themeSwitch: { enabled: false },
    // `links` intentionally omitted — text items live in `navLinks`
    // and are rendered by `NavHeader`.
  }
}
